const ScoreBoard = ({ myName, myScore, oppName, oppScore, round }) => (
  <>
    <div className="game-header">
      <div className="player-info me">
        <div className="player-label">You · {myName}</div>
        <div className="player-score">{myScore}</div>
      </div>
      <div className="vs-text">VS</div>
      <div className="player-info opp">
        <div className="player-label">{oppName || "Opponent"}</div>
        <div className="player-score">{oppScore}</div>
      </div>
    </div>
    <div className="round-badge">
      <span>Round {round}</span>
    </div>
  </>
);

export default ScoreBoard;